import {
  Component,
  EventEmitter,
  forwardRef,
  HostBinding,
  HostListener,
  Input,
  Output,
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

type SwitchColor =
  | 'primary'
  | 'success'
  | 'warning'
  | 'danger'
  | 'info'
  | 'neutral'
  | 'analog'
  | 'contrast';

@Component({
  selector: 'app-switch-button',
  template: '',
  styleUrls: ['switch-button.component.scss'],
  standalone: true,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SwitchButtonComponent),
      multi: true,
    },
  ],
})
export class SwitchButtonComponent {
  @Input() color: SwitchColor;
  @Input() disabled: boolean = false;

  checked: boolean = false;

  private onChange: (value: boolean) => void = () => {};
  private onTouched: () => void = () => {};

  @HostBinding('class.input--check') get isChecked() {
    return this.checked;
  }

  @HostBinding('class.switch--primary') get primary() {
    return this.color === 'primary';
  }

  @HostBinding('class.switch--success') get success() {
    return this.color === 'success';
  }

  @HostBinding('class.switch--warning') get warning() {
    return this.color === 'warning';
  }

  @HostBinding('class.switch--danger') get danger() {
    return this.color === 'danger';
  }

  @HostBinding('class.switch--info') get info() {
    return this.color === 'info';
  }

  @HostBinding('class.switch--neutral') get neutral() {
    return this.color === 'neutral';
  }

  @HostBinding('class.switch--analog') get analog() {
    return this.color === 'analog';
  }

  @HostBinding('class.switch--contrast') get contrast() {
    return this.color === 'contrast';
  }

  @HostListener('click')
  toggle() {
    if (this.disabled) {
      return;
    }

    this.checked = !this.checked;
    this.onChange(this.checked);
    this.onTouched();
  }

  writeValue(value: boolean): void {
    this.checked = !!value;
  }

  registerOnChange(fn: (value: boolean) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
